import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMDXComponents as _provideComponents } from "next-mdx-import-source-file";
function _createMdxContent(props) {
    const _components = Object.assign({
        p: "p",
        h2: "h2",
        ul: "ul",
        li: "li",
        strong: "strong"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
        children: [
            _jsx(_components.p, {
                children: 'Welcome to asadatik.dev! This cookie policy ("Policy") explains how Asaduzzaman Atik ("I," "me," "my," or "mine") uses cookies and similar tracking technologies when you visit and use this personal website. By accessing and using asadatik.dev, you consent to the use of cookies and other tracking technologies as described in this Policy. If you do not agree to the use of cookies, please adjust your browser settings or refrain from using the Website. 👍'
            }),
            "\n",
            _jsx(_components.h2, {
                children: "1. What are Cookies? 🍪"
            }),
            "\n",
            _jsx(_components.p, {
                children: "Cookies are small data files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work efficiently and to provide information to website owners about how users interact with their sites."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "2. How I Use Cookies 🍪"
            }),
            "\n",
            _jsx(_components.p, {
                children: "I use cookies and similar tracking technologies on asadatik.dev for the following purposes:"
            }),
            "\n",
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            "\n",
                            _jsxs(_components.p, {
                                children: [
                                    _jsx(_components.strong, {
                                        children: "Essential Cookies:"
                                    }),
                                    " These cookies are necessary for the operation of the Website. They enable core functionality, such as security, network management, and accessibility."
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            "\n",
                            _jsxs(_components.p, {
                                children: [
                                    _jsx(_components.strong, {
                                        children: "Google Tag Manager:"
                                    }),
                                    " I use Google Tag Manager to track user interactions on the Website. This helps me understand how visitors engage with the site to improve its content and user experience. However, I do not collect any personally identifiable information through this tracking."
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            "\n",
                            _jsxs(_components.p, {
                                children: [
                                    _jsx(_components.strong, {
                                        children: "Analytical Cookies:"
                                    }),
                                    " These cookies help me analyze how visitors use asadatik.dev, allowing me to measure and improve site performance. The information collected is aggregated and anonymous."
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            "\n",
            _jsx(_components.h2, {
                children: "3. Third-Party Cookies 🍪"
            }),
            "\n",
            _jsx(_components.p, {
                children: "Some of the cookies on asadatik.dev may be placed by third-party service providers, such as Google Analytics. These third parties may use cookies and other tracking technologies to collect information about your use of the Website. Please review the privacy policies of these third-party providers to understand how they handle your data."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "4. Managing Cookies 🍪"
            }),
            "\n",
            _jsx(_components.p, {
                children: "You can control and manage cookies in your browser settings. Most web browsers allow you to accept or reject cookies, delete stored cookies, and be notified when a cookie is sent. Please note that if you choose to disable or reject cookies, some features and functionalities of asadatik.dev may not work properly."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "5. Updates to this Cookie Policy 🔄"
            }),
            "\n",
            _jsx(_components.p, {
                children: "I may update this cookie policy from time to time to reflect changes in my practices or for other operational, legal, or regulatory reasons. Any changes will be effective immediately upon posting the updated policy on the Website."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "6. Contact 📞"
            }),
            "\n",
            _jsx(_components.p, {
                children: "For any inquiries or questions regarding this Cookie Policy or any issues related to asadatik.dev, please contact me at asadatik.me@gmail.com."
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = Object.assign({}, _provideComponents(), props.components);
    return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
        children: _jsx(_createMdxContent, props)
    })) : _createMdxContent(props);
}
export default MDXContent;
